import { useState } from "react"
import { useLocalization } from "@tm/localization"
import { ConfigParams } from "@tm/models"
import Morpheus from "@tm/morpheus"
import { Button, ConfirmationDialog, Icon } from "@tm/components"
import { SubUser } from "../../../data/model"

type Props = {
    subUser: SubUser
    disabled: boolean
    onDelete(subUser: SubUser): void
}

export default function SubUserDeleteComponent({ subUser, disabled, onDelete }: Props) {
    const { translateText } = useLocalization()
    const { deleteButtonColorError } = Morpheus.getParams<ConfigParams>()
    const [deleteDialogOpen, setDeleteDialogOpen] = useState(false)

    return (
        <>
            <Button
                size="small"
                color={deleteButtonColorError ? "error" : undefined}
                startIcon={<Icon name="delete" />}
                title={translateText(1239)}
                onClick={() => setDeleteDialogOpen(true)}
                disabled={disabled}
            />
            {deleteDialogOpen && 
            <ConfirmationDialog
                skin={deleteButtonColorError ? "warning" : undefined}
                open
                confirmationButtonText={translateText(585)}
                cancelButtonText={translateText(584)}
                onOutsideClick={() => setDeleteDialogOpen(false)}
                onConfirm={() => onDelete(subUser)}
                onCancel={() => setDeleteDialogOpen(false)}
            >
                {translateText(translateText(1258))}
            </ConfirmationDialog>}
        </>
    )
}
